import type { ApiFetchLoyaltyHubPort } from '~/handlers/ports/api-fetch-loyalty-hub.port';
import type { LoyaltyHubContent } from '~/types/loyalty-hub';
import { getApostatudoApiUrl } from '~/utils/apostatudo/get-apostatudo-api-url';

// Endpoint do core AINDA NÃO EXISTE — o contrato (types/loyalty-hub.ts) foi
// definido manualmente pra o backend construir em cima. Enquanto /loyalty-hub
// não responde, este adapter retorna null e o handler cai no fallback bundlado
// (assets/json/loyaltyHub.json). Quando o core subir o endpoint no mesmo shape,
// ele passa a ser a fonte de verdade sem mais nenhuma mudança de front.
export class ApostatudoApiFetchLoyaltyHubAdapter
  implements ApiFetchLoyaltyHubPort
{
  async handle(): Promise<LoyaltyHubContent | null> {
    const url = `${getApostatudoApiUrl()}/loyalty-hub`;

    const response = await fetch(url, {
      method: 'GET',
      headers: { Accept: 'application/json' },
    });

    if (!response.ok) {
      console.warn(
        `[ApiFetchLoyaltyHub] API returned ${response.status}: ${response.statusText}`,
      );

      return null;
    }

    const json = await response.json();
    const data = (json?.data ?? json) as LoyaltyHubContent | undefined;

    if (!data || !Array.isArray(data.cards)) {
      console.warn('[ApiFetchLoyaltyHub] resposta sem cards:', json);

      return null;
    }

    return data;
  }
}
